"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiConstants = void 0;
var ApiConstants = /** @class */ (function () {
    function ApiConstants() {
    }
    ApiConstants.ProductSearchBase = "partial/ProductSearch";
    ApiConstants.ProductSearchProducts = "Products";
    ApiConstants.ProductSearchSubCategories = "SubCategories";
    ApiConstants.ProductSearchBrands = "Brands";
    ApiConstants.ProductSearchFilterBar = "FeaturesFilter";
    ApiConstants.BookMarkedProducts = "partial/BookMarkedProducts";
    ApiConstants.ProductDetail = "partial/ProductDetail";
    return ApiConstants;
}());
exports.ApiConstants = ApiConstants;
